import tinymce from 'tinymce';

/* Default icons are required. After that, import custom icons if applicable */
import 'tinymce/icons/default/icons.min.js';

/* Required TinyMCE components */
import 'tinymce/themes/silver/theme.min.js';
import 'tinymce/models/dom/model.min.js';

/* Import a skin (can be a custom skin instead of the default) */
import 'tinymce/skins/ui/oxide/skin.js';

/* Import plugins */
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/codesample';
import 'tinymce/plugins/image';
import 'tinymce/plugins/media';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/wordcount';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/code';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/emoticons/js/emojis';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/table';
import 'tinymce/plugins/quickbars';

/* content UI CSS is required */
import 'tinymce/skins/ui/oxide/content.js';

/* The default content CSS can be changed or replaced with appropriate CSS for the editor content. */
import 'tinymce/skins/content/default/content.js';


//const cssModules = import.meta.glob('/tinymce/themes/**/*.css', { eager: true });
//const jsModules = import.meta.glob('/tinymce/themes/**/*.css', { eager: true });

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    // Remove any existing editor instance for this element
    const existingEditor = tinymce.get(this.element.id);
    if (existingEditor) {
      existingEditor.remove();
    }

    tinymce.init({
      license_key: 'gpl',
      plugins: [
        // Core editing features
        'anchor', 'autolink', 'charmap', 'codesample', 'emoticons', 'image', 'link', 'lists', 'media', 'searchreplace', 'table', 'visualblocks', 'wordcount', 'quickbars'
        //   // Your account includes a free trial of TinyMCE premium features
        //   // Try the most popular premium features until Dec 17, 2024:
        //   'checklist', 'mediaembed', 'casechange', 'export', 'formatpainter', 'pageembed', 'a11ychecker', 'tinymcespellchecker', 'permanentpen', 'powerpaste', 'advtable', 'advcode', 'editimage', 'advtemplate', 'ai', 'mentions', 'tinycomments', 'tableofcontents', 'footnotes', 'mergetags', 'autocorrect', 'typography', 'inlinecss', 'markdown',
        //   // Early access to document converters
        //   'importword', 'exportword', 'exportpdf'
      ],
      promotion: false,
      branding: false,
      target: this.element,
      toolbar: 'undo redo | blocks | bold italic strikethrough forecolor backcolor blockquote | link image media | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | removeformat',
      setup: (editor) => {
        editor.on('init', () => {
          console.log('TinyMCE editor initialized, dispatching tinymce:ready event');
          this.element.dispatchEvent(new CustomEvent('tinymce:ready', {
            bubbles: true,
            detail: { editor: editor }
          }));
        });
      }
    });
  }

  disconnect() {
    const editor = tinymce.get(this.element.id);
    if (editor) {
      editor.remove();
    }
  }
}


